import axios, { AxiosError } from "axios";
import { apiConfig, generateURL } from "./BaseApiService";
export class VerificationService {
    constructor(environment) {
        this.environment = environment;
    }
    async fetchPendingData(verificationKey, oauthState) {
        var _a, _b;
        try {
            const response = await axios.post(generateURL(this.environment.API_BASE_URL, "/auth/verification/pending"), { verificationKey, oauthState }, { ...apiConfig(), withCredentials: true });
            const data = response.data;
            return { ok: true, ...data };
        }
        catch (err) {
            if (err instanceof AxiosError && ((_a = err.response) === null || _a === void 0 ? void 0 : _a.data) && typeof err.response.data === "object") {
                const data = err.response.data;
                return { ok: false, code: (_b = data.code) !== null && _b !== void 0 ? _b : "unknown" };
            }
            return { ok: false, code: "unknown" };
        }
    }
    async sendVerification(verificationKey, phone, purpose) {
        var _a;
        try {
            await axios.post(generateURL(this.environment.API_BASE_URL, "/auth/verification/send"), { verificationKey, phone, purpose }, { ...apiConfig(), withCredentials: true });
            return { ok: true };
        }
        catch (err) {
            if (err instanceof AxiosError && ((_a = err.response) === null || _a === void 0 ? void 0 : _a.data) && typeof err.response.data === "object") {
                const data = err.response.data;
                if (data.code === "rate_limited") {
                    return { ok: false, code: "rate_limited", retryAfterSeconds: data.retryAfterSeconds };
                }
                if (data.code === "invalid_us_phone_number") {
                    return { ok: false, code: "invalid_us_phone_number" };
                }
                if (data.code === "notification_dispatch_failed") {
                    return { ok: false, code: "notification_dispatch_failed" };
                }
            }
            return { ok: false, code: "unknown" };
        }
    }
    async submitVerificationCode(verificationKey, phone, code, purpose) {
        var _a;
        try {
            const response = await axios.put(generateURL(this.environment.API_BASE_URL, "/auth/verification/verify"), { verificationKey, phone, code, purpose }, { ...apiConfig(), withCredentials: true });
            return { ok: true, purpose: response.data.purpose };
        }
        catch (err) {
            if (err instanceof AxiosError && ((_a = err.response) === null || _a === void 0 ? void 0 : _a.data) && typeof err.response.data === "object") {
                const data = err.response.data;
                if (data.code) {
                    return { ok: false, code: data.code };
                }
            }
            return { ok: false, code: "unknown" };
        }
    }
    async completeVerification(verificationKey, firstName, lastName, dateOfBirth, phone) {
        var _a, _b;
        try {
            const response = await axios.post(generateURL(this.environment.API_BASE_URL, "/auth/verification/complete"), { verificationKey, firstName, lastName, dateOfBirth, phone }, { ...apiConfig(), withCredentials: true });
            const data = response.data;
            return { ok: true, ...data };
        }
        catch (err) {
            if (err instanceof AxiosError && ((_a = err.response) === null || _a === void 0 ? void 0 : _a.data) && typeof err.response.data === "object") {
                const data = err.response.data;
                return { ok: false, code: (_b = data.code) !== null && _b !== void 0 ? _b : "unknown" };
            }
            return { ok: false, code: "unknown" };
        }
    }
}
